import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Alert } from '../../../../../design/alert/S_Alert';

interface IProps {
  showTemplateProjectAlert: boolean;
}

export const TemplateProjectInfo = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <>
      {props.showTemplateProjectAlert && (
        <S_Alert color='info'>
          <strong>{t('info')} </strong>
          {t('template_project_info')}
        </S_Alert>
      )}
    </>
  );
});
